import LegalPage from "../../components/LegalPage";

export default function Cookies() {
  return (
    <LegalPage title="Politique de cookies" kicker="Cookies">
      <h2>1. Qu&apos;est-ce qu&apos;un cookie ?</h2>
      <p>
        Un cookie est un petit fichier déposé sur le terminal de
        l&apos;utilisateur lors de la navigation, permettant notamment
        d&apos;assurer le bon fonctionnement du site et la session de
        connexion.
      </p>
      <h2>2. Cookies utilisés</h2>
      <ul>
        <li>
          <strong>Session</strong> : authentification du joueur (essentiel).
        </li>
        <li>
          <strong>Préférences</strong> : pseudo, langue (essentiel).
        </li>
        <li>
          <strong>Paiement</strong> : Stripe (essentiel, déposé par Stripe).
        </li>
      </ul>
      <h2>3. Cookies tiers</h2>
      <p>
        OTRAQUIZZ n&apos;utilise aujourd&apos;hui aucun cookie publicitaire
        ni traceur tiers.
      </p>
      <h2>4. Gestion</h2>
      <p>
        Vous pouvez à tout moment supprimer les cookies depuis les
        paramètres de votre navigateur.
      </p>
    </LegalPage>
  );
}
